module.exports = __webpack_public_path__ + "media/logos/lexshares-logo-icon-9cbf6225.png";